import React, { FC } from 'react';
import {
  Form, Typography, Input, DatePicker, Select,
} from 'antd';

import moment from 'moment';
import { DATE_WITH_DASH } from '../../../constants/time-formats';
import { ContainerWithForm, FormContainer } from '../../../components/Container';
import FooterNavigator from '../../../components/FooterNavigator';
import { PHN_CONFIRMATION, PHN_GP_DETAILS } from '../../../constants/routes';
import { useAppDispatch } from '../../../hooks/redux-hooks';
import { removeEmptyStrFields } from '../../../utils/object-check';
import { updateRefererData } from '../../../redux/slices/booking';
import { mobileRegxPattern, trimPhoneNumber } from '../../../utils/phone-number';
import { PHN_OPTIONS } from '../../../constants/phn-options';
import { getPrivateReferrerDetailsConfig } from '../../../config/privateBooking';

const HncRefererDetails: FC = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { showPhn, firstNameLabel, lastNameLabel, phoneLabel, emailLabel, title } = getPrivateReferrerDetailsConfig();
  // analytics.logPageViewEvent(REFERRAL_DETAILS, {
  //   site: SITE_NAME,
  //   page_path: pathname,
  // });

  const submit = async () => {
    try {
      await form.validateFields();
      const values = await form.validateFields();
      const cleanedValues = removeEmptyStrFields(values);
      dispatch(updateRefererData({ ...cleanedValues, referrerStartDate: moment().format(DATE_WITH_DASH) }));
      return true;
    } catch (error) {
      // analytics.trackVpcFormError({
      //   form_id: bookingData.formId,
      //   error_type: error,
      //   page_path: pathname,
      // });
      return false;
    }
  };

  return (
    <ContainerWithForm>
      <Typography.Title level={2} style={{ marginBottom: '20px', color: '#5f6369', fontSize: '36px' }}>
        {title}
      </Typography.Title>

      <FormContainer
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="firstName"
          label={firstNameLabel}
          required
          rules={[{ required: true, message: `Please enter ${firstNameLabel}` }]}
        >
          <Input placeholder={`Enter ${firstNameLabel}`} />
        </Form.Item>

        <Form.Item
          name="lastName"
          label={lastNameLabel}
          rules={[{ required: true, message: `Please enter ${lastNameLabel}` }]}
        >
          <Input placeholder={`Enter ${lastNameLabel}`} />
        </Form.Item>

        {showPhn && (
        <Form.Item
          name="referrerPHN"
          required
          rules={[
            {
              required: true,
              message: 'Please select Which PHN the patient comes from.',
            },
          ]}
          label="Referrer PHN"
        >
          <Select>
            {PHN_OPTIONS.map((option) => (
              <Select.Option key={option} value={option}>
                {option}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        )}
        <Form.Item
          name="phone"
          label={phoneLabel}
          normalize={trimPhoneNumber}
          rules={[
            { required: true, message: `Please enter ${phoneLabel}` },
            {
              pattern: mobileRegxPattern,
              message: 'Please input a valid phone number.',
            },
          ]}
        >
          <Input placeholder={`Enter ${phoneLabel}`} />
        </Form.Item>

        <Form.Item
          name="email"
          label={emailLabel}
          rules={[
            { required: true, message: `Please enter ${emailLabel}` },
            { type: 'email', message: 'Please enter valid email address' },
          ]}
        >
          <Input placeholder={`Enter ${emailLabel}`} />
        </Form.Item>

        <Form.Item
          name="referrerStartDate"
          label="Referral Date"
        >
          <DatePicker
            format={DATE_WITH_DASH}
            style={{ width: '100%' }}
            disabled
            defaultValue={moment()}
          />
        </Form.Item>
      </FormContainer>

      <FooterNavigator
        error=""
        submit={submit}
        next={PHN_CONFIRMATION}
        back={PHN_GP_DETAILS}
        containerStyle={{ marginTop: '40px' }}
      />
    </ContainerWithForm>
  );
};

export default HncRefererDetails;
